import * as React from 'react';

import { useDropzone } from 'react-dropzone';

import { Button, ButtonContainer } from '@emburse/ui-core';

import * as style from './Dropzone.styl';

interface IDropzoneProps {
  customBodyText?: string;
  customButtonText?: string;
  customCallback?: () => void;
  isDragging?: boolean;
  multiple: boolean;
  onDragEnter: () => void;
  onDragLeave: () => void;
  onDrop: (acceptedFiles: any) => void;
  hideActionButton?: boolean;
  customDropzoneContent?: any;
}

function callCustomCallback(e: React.MouseEvent, customCallback: () => void) {
  e.stopPropagation();
  customCallback();
}

function renderDropzoneContent(
  isDragging: boolean,
  hideActionButton?: boolean,
  customBodyText?: string,
  customButtonText?: string,
  customCallback?: () => void
) {
  return isDragging ? (
    <div className="flexbox fd-c">
      <span className="dropzone-content">Drop your file here</span>
    </div>
  ) : (
    <div className="flexbox fd-c">
      <span className="dropzone-content">{customBodyText || 'Drag a CSV file here'}</span>
      {!hideActionButton && renderActionButton(customCallback, customButtonText)}
    </div>
  );
}

function renderActionButton(customCallback?: () => void, customButtonText?: string) {
  const buttonOnClick = customCallback ? (e: React.MouseEvent) => callCustomCallback(e, customCallback) : null;

  return (
    <>
      <span className="dropzone-content">or</span>
      <ButtonContainer className="flex jc-c">
        <Button type="button" variant="outlined" onClick={buttonOnClick}>
          {customButtonText || 'Choose a File'}
        </Button>
      </ButtonContainer>
    </>
  );
}

export const Dropzone: React.FC<IDropzoneProps> = (props) => {
  const {
    customCallback,
    customBodyText,
    customButtonText,
    isDragging,
    multiple,
    onDragEnter,
    onDragLeave,
    onDrop,
    hideActionButton,
    customDropzoneContent
  } = props;

  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    onDrop: (acceptedFiles) => onDrop(acceptedFiles),
    onDragEnter: () => onDragEnter(),
    onDragLeave: () => onDragLeave()
  });

  return (
    <div {...getRootProps()} className={style.global + ' file-dropzone center flexbox fd-c jc-c' + (isDragging ? ' is-dragging' : '')}>
      <input {...getInputProps()} />
      {customDropzoneContent || (
        <div>
          <span className="center icon icon-upload" />
          {renderDropzoneContent(isDragging, hideActionButton, customBodyText, customButtonText, customCallback)}
        </div>
      )}
    </div>
  );
};
